import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SummaryByTerritoryReportComponent } from './summary-by-territory-report.component';

const routes: Routes = [
  {
    path:'**',
    component: SummaryByTerritoryReportComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SummaryByTerritoryReportRoutingModule { }
